<script setup>
  import { computed, useAttrs } from "vue";

  import IcReset from "@/assets/images/svg-component/IcReset.vue";
  import IcSearch from "@/assets/images/svg-component/IcSearch.vue";

  const props = defineProps({
    onlySearchButton: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
  });
  const emits = defineEmits(["reset", "submit"]);
  const attrs = useAttrs();

  const filteredAttrs = computed(() => {
    const { class: _c, style: _s, ...rest } = attrs;
    return rest;
  });
</script>

<template>
  <div class="search-box" v-bind="filteredAttrs">
    <div class="search-items">
      <slot name="items" />
    </div>

    <div class="search-btns">
      <slot name="actions">
        <ui-button
          v-if="!onlySearchButton"
          variant="outlined"
          color="gray"
          class="min-w-[48px] px-0"
          @click="emits('reset')"
        >
          <template #icon
            ><n-icon :size="20"><IcReset /></n-icon
          ></template>
        </ui-button>
        <ui-button
          :loading="isLoading"
          variant="outlined"
          @click="emits('submit')"
        >
          <template #icon
            ><n-icon :size="20"><IcSearch /></n-icon
          ></template>
          검색
        </ui-button>
      </slot>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .search-box {
    width: 100%;
    border-radius: 0.75rem;
    background: var(--smoe-primary-50);
    display: flex;
    padding: 1.5rem;
    justify-content: space-between;
    align-items: center;
    &.no-bg {
      background: none;
      padding: 0;
      border-radius: 0;
      align-items: flex-end;
      gap: 1rem;
      .search-items {
        gap: 0.5rem;
      }
    }
    .search-items {
      flex: auto;
      display: flex;
      align-items: flex-start;
      gap: 1.5rem;
    }
    .search-btns {
      display: flex;
      align-items: center;
      gap: 0.5rem;
    }
  }
</style>
